import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { DEALER } from "@/data/dealer";

const Row = ({ icon: Icon, label, children }) => (
  <li className="flex gap-4 border-b border-line py-5 first:pt-0 last:border-0">
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-ink text-white" aria-hidden="true">
      <Icon className="h-5 w-5" />
    </span>
    <div className="min-w-0">
      <p className="text-xs font-bold uppercase tracking-[0.16em] text-steel">{label}</p>
      <div className="mt-1 text-[15px] leading-relaxed text-ink">{children}</div>
    </div>
  </li>
);

export const ContactList = ({ prefix = "contact" }) => (
  <ul data-testid={`${prefix}-details`}>
    <Row icon={Phone} label="Call">
      <a href={DEALER.phone.href} className="link-underline font-display text-xl font-bold" data-testid={`${prefix}-phone-link`}>
        {DEALER.phone.display}
      </a>
    </Row>
    <Row icon={Mail} label="Email">
      <a href={`mailto:${DEALER.email}`} className="link-underline break-all font-semibold" data-testid={`${prefix}-email-link`}>
        {DEALER.email}
      </a>
    </Row>
    <Row icon={MapPin} label="Address">
      <address className="not-italic">
        {DEALER.address.line1}, {DEALER.address.town}, {DEALER.address.postcode}
      </address>
      <a
        href={DEALER.mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="link-underline mt-1 inline-flex items-center gap-1 text-sm font-semibold text-brand"
        data-testid={`${prefix}-directions-link`}
      >
        Get directions <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
      </a>
    </Row>
  </ul>
);
